import { render, staticRenderFns } from "./PigPartsView.vue?vue&type=template&id=3bb20a06"
import script from "./PigPartsView.vue?vue&type=script&lang=js"
export * from "./PigPartsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports